import { Autocomplete } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

export function SetPage(props) {
  const { pageSize, entriesStart, entriesEnd, totalData, onChange } = props;
  return (
    <MDBox display="flex" alignItems="center">
      <MDTypography variant="button" color="secondary" fontWeight="regular">
        Showing {entriesStart} to {entriesEnd} of {totalData} entries
      </MDTypography>
      <Autocomplete
        disableClearable
        value={pageSize ? pageSize.toString() : "10"}
        options={["10", "20", "30", "40", "50"]}
        onChange={onChange}
        size="small"
        sx={{ marginLeft:"1rem", width: "5rem" }}
        renderInput={(params) => <MDInput {...params} />}
      />
      <MDTypography variant="caption" color="secondary">
        &nbsp;&nbsp;entries per page
      </MDTypography>
    </MDBox>
  );
}
